// supporting browsers that do not have Intl.PluralRules (e.g IE11 & Safari 12-)
// https://github.com/formatjs/react-intl/blob/master/docs/Upgrade-Guide.md#migrate-to-using-native-intl-apis
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/en';
import '@formatjs/intl-pluralrules/dist/locale-data/es';
// supporting browsers that do not have Intl.RelativeTimeFormat (e.g IE11, Edge, Safari 13-)
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/dist/locale-data/en';
import '@formatjs/intl-relativetimeformat/dist/locale-data/es';
import 'moment/locale/es-us';
import 'moment/locale/pt-br';

import { Locale } from '@lib/providers/LanguageProvider';

import enUSTranslationMessages from './locales/en-US.json';
import esUSTranslationMessages from './locales/es-US.json';
import ptBRTranslationMessages from './locales/pt-BR.json';

const translationMessages = {
  [Locale.EnglishUS]: enUSTranslationMessages,
  [Locale.SpanishUS]: esUSTranslationMessages,
  [Locale.PortugueseBR]: ptBRTranslationMessages,
};

export default translationMessages;
